import { css } from '@emotion/react';
import type { ReactElement, ReactNode } from 'react';

import { styled } from '../../../../../styled';

type Interface = { className: string; children: ReactNode };

const Component = ({ className, children }: Interface): ReactElement => {
	return <div className={className}>{children}</div>;
};

const ChatFieldContainer = styled(Component)(
	css`
		div& * {
			box-sizing: border-box;
		}
	`
);

export { ChatFieldContainer };
